import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";
import img from "../../../../assets/media/images/invitation_img.png";
import { CustomTextField } from "assets/styles/globalStyledComponent";
import { useMutation, useQuery } from "react-query";
import {
  getInvitationCode,
  updateInvitationCode,
} from "app/services/management";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import { queryClient } from "App";
import { useFormik } from "formik";
import * as yup from "yup";
import { THEME } from "app/config/constants";
import { PencilSquare } from "react-bootstrap-icons";
import YoutubeVideoDialog from "app/components/common/Dialogs/YoutubeVideoDialog";
import { YouTube } from "@mui/icons-material";
import DialogHeader from "app/components/common/DialogHeader";
const validationSchema = yup.object({
  code: yup
    .string("invitation code required")
    .required("invitation code required"),
});
const InvitationCodeDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    values,
    setValues,
    handleSubmit,
    handleChange,
    errors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: {
      code: "",
      edit: false,
    },
    validationSchema,
    onSubmit: (values) => {
      updateInviationCode(values.code);
    },
  });
  const [openYoutubeDialog, setOpenYoutubeDialog] = useState(false);

  const { isLoading: invitationCodeLoading, isFetching } = useQuery({
    queryKey: ["getInvitationCode"],
    queryFn: () => getInvitationCode(),
    enabled: open,
    onSuccess: (data) => {
      setValues((prev) => ({ ...prev, code: data?.data?.Obj?.schoolCode }));
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    },
  });

  const { mutate: updateInviationCode, isLoading: updateInviationCodeLoading } =
    useMutation(updateInvitationCode, {
      onSuccess: (data) => {
        toast.success(data?.data?.message);
        resetForm();
        setValues({ code: "", edit: false });
        queryClient.invalidateQueries({ queryKey: ["getInvitationCode"] });
        onClose();
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message);
      },
    });

  const videoLink = [
    {
      link: "https://www.youtube.com/embed/WwUVghQu7Eo?si=624Y8MO1sX0-raWX",
      title: "How to Create & Update Invitation Code",
    },
  ];

  const handleClose = () => {
    resetForm();
    setValues({ code: "", edit: false });
    onClose();
  };
  return (
    <>
      <YoutubeVideoDialog
        open={openYoutubeDialog}
        handleCloseDialog={() => setOpenYoutubeDialog(false)}
        videoLink={videoLink}
      />

      <Dialog
        open={Boolean(open)}
        onClose={handleClose}
        fullScreen={isMobile}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: isMobile ? "100%" : "auto",
          },
        }}
      >
        <DialogTitle sx={{ p: "0 !important" }}>
          <DialogHeader
            title="School Invitation Code"
            handleClose={handleClose}
          />
        </DialogTitle>

        <DialogContent>
          <Stack
            sx={{ 
              minHeight: { xs: "300px", sm: "400px" },
              py: { xs: 1, sm: 2 },
              px: { xs: 1, sm: 2 }
            }}
            justifyContent="center"
            alignItems="center"
          >
            {invitationCodeLoading || isFetching ? (
              <CircularProgress size={30} color="secondary" />
            ) : (
              <CardWrapper>
                <Stack
                  direction="row"
                  justifyContent="center"
                  sx={{ mt: "-45px" }}
                >
                  <Image src={img} />
                </Stack>
                <form onSubmit={handleSubmit}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    gap={1}
                    sx={{ 
                      marginTop: { xs: "1.5rem", sm: "2rem" },
                      flexWrap: "wrap"
                    }}
                  >
                    <Typography 
                      variant="h5"
                      sx={{
                        fontSize: { xs: "1.25rem", sm: "1.5rem" },
                        textAlign: "center"
                      }}
                    >
                      School Code For Invitation
                    </Typography>
                    <IconButton
                      onClick={() => setOpenYoutubeDialog(true)}
                      sx={{ 
                        color: "#FF0000",
                        fontSize: { xs: "2rem", sm: "3rem" }
                      }}
                    >
                      <YouTube />
                    </IconButton>
                  </Stack>

                  <Box className="input_wrapper">
                    <CustomTextField
                      autoFocus={values.edit}
                      disabled={!values.edit}
                      focused={values.edit}
                      fullWidth
                      size="medium"
                      value={values.code}
                      error={Boolean(errors.code) && touched.code}
                      helperText={touched.code && errors.code}
                      name="code"
                      onChange={handleChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <PencilSquare
                              onClick={() =>
                                setValues((prev) => ({
                                  ...prev,
                                  edit: !prev.edit,
                                }))
                              }
                              size={18}
                              style={{
                                color: THEME.primary,
                                cursor: "pointer",
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    sx={{ marginTop: "20px", marginBottom: isMobile ? "20px" : "0" }}
                  >
                    <LoadingButton
                      loading={updateInviationCodeLoading}
                      variant="contained"
                      size="large"
                      color="secondary"
                      className="button"
                      type="submit"
                      disabled={!values.edit}
                    >
                      UPDATE Code
                    </LoadingButton>
                  </Stack>
                </form>
              </CardWrapper>
            )}
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InvitationCodeDialog;

const Image = styled.img`
  width: 90.34px;
  height: 91px;
  object-fit: cover;
  
  @media (max-width: 600px) {
    width: 70px;
    height: 71px;
  }
`;
const CardWrapper = styled.div`
  width: 100%;
  max-width: 475.18px;
  min-height: 290.34px;
  background: #ffffff;
  border: 1px solid #b6c8d6;
  border-radius: 21px;
  padding: 0 16px;
  
  @media (max-width: 600px) {
    max-width: 100%;
    min-height: auto;
    padding: 0 12px;
  }
  
  .text {
    margin-top: 27px;
    font-size: 20px;
    font-weight: 500;
    color: #232360;
    text-align: center;
    
    @media (max-width: 600px) {
      font-size: 18px;
      margin-top: 20px;
    }
  }
  .input_wrapper {
    width: 100%;
    max-width: 405px;
    margin: auto;
    margin-top: 25px;
    
    @media (max-width: 600px) {
      max-width: 100%;
      margin-top: 20px;
    }
  }
  .button {
    width: 100%;
    max-width: 270px;
    border-radius: 10px;
    font-style: normal;
    
    @media (max-width: 600px) {
      max-width: 100%;
    }
  }
`;
